/**
 * Teklif ve iletişim formları — yalnızca doğrulanmış başarı.
 * Shopify Google kanalı sayfa görüntülemeyi zaten gönderir; bu dosya
 * sayfa görüntülemesi tekrarlamaz. Dönüşüm olayı bir gönderim için bir kez gider.
 */
(function () {
  'use strict';

  var GOOGLE_TAG_ID = 'GT-5TWG87PN';
  var DEDUPE_MS = 20000;
  var NAMES = {
    'forms-root-977252': 'request_quote',
    '977252': 'request_quote',
    'forms-root-1015099': 'contact',
    '1015099': 'contact',
    'forms-root-981667': 'custom_cabinet',
    '981667': 'custom_cabinet',
    'forms-root-1031410': 'resources',
    '1031410': 'resources'
  };
  var SUCCESS = [
    'thank you',
    'thanks for',
    'message sent',
    'we received',
    'successfully',
    'teşekkür',
    'tesekkur',
    'gönderildi',
    'gonderildi',
    'talebiniz',
    'alınmıştır',
    'alinmistir'
  ];
  var firedAt = {};
  var tagReady = false;

  function formName(id) {
    return NAMES[id] || 'lead_form';
  }

  function canonicalId(id) {
    return String(id || '').replace(/^forms-root-/, '');
  }

  function ensureTag() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };
    if (tagReady) return;
    tagReady = true;
    window.gtag('js', new Date());
    window.gtag('config', GOOGLE_TAG_ID, { send_page_view: false });
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + GOOGLE_TAG_ID;
    document.head.appendChild(script);
  }

  function captureClickIds() {
    var params = new URLSearchParams(window.location.search || '');
    ['gclid', 'gbraid', 'wbraid'].forEach(function (key) {
      var value = params.get(key);
      if (!value) return;
      document.cookie = 'vatpan_' + key + '=' + encodeURIComponent(value) + ';path=/;max-age=7776000;SameSite=Lax';
    });
  }

  window.vatpanTrackLead = function (formId, name) {
    var id = canonicalId(formId);
    if (!id) return false;
    var now = Date.now();
    if (firedAt[id] && now - firedAt[id] < DEDUPE_MS) return false;
    firedAt[id] = now;
    ensureTag();
    var leadName = name || formName(id);
    window.dataLayer.push({
      event: 'vatpan_lead',
      vatpan_form_id: id,
      vatpan_form_name: leadName,
      vatpan_page: window.location.pathname
    });
    window.gtag('event', 'generate_lead', {
      send_to: GOOGLE_TAG_ID,
      form_id: id,
      form_name: leadName,
      page_location: window.location.href
    });
    return true;
  };

  window.vatpanTrackWhatsapp = function (itemName) {
    var now = Date.now();
    if (firedAt.whatsapp && now - firedAt.whatsapp < DEDUPE_MS) return false;
    firedAt.whatsapp = now;
    ensureTag();
    window.dataLayer.push({
      event: 'vatpan_whatsapp_click',
      vatpan_page: window.location.pathname,
      vatpan_item_name: itemName || ''
    });
    window.gtag('event', 'whatsapp_click', {
      send_to: GOOGLE_TAG_ID,
      item_name: itemName || '',
      page_location: window.location.href,
      language: document.documentElement.lang || ''
    });
    return true;
  };

  window.vatpanMarkLeadPending = function (hostOrId, name) {
    var host = hostOrId && hostOrId.getAttribute ? hostOrId : null;
    if (!host && hostOrId) {
      host = document.querySelector('[data-forms-id="forms-root-' + hostOrId + '"]')
        || document.querySelector('[data-forms-id="' + hostOrId + '"]');
    }
    if (!host) return;
    host.setAttribute('data-vatpan-lead-pending', '1');
    if (name) host.setAttribute('data-vatpan-lead-name', name);
  };

  function shadowText(host) {
    var chunks = [];
    var stack = [host];
    while (stack.length) {
      var node = stack.pop();
      if (!node) continue;
      if (node === host || node.nodeType === 11) chunks.push(node.textContent || '');
      if (!node.querySelectorAll) continue;
      node.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) stack.push(el.shadowRoot);
      });
    }
    return chunks.join(' ').replace(/\s+/g, ' ').toLowerCase();
  }

  function showsSuccess(host) {
    var text = shadowText(host);
    for (var i = 0; i < SUCCESS.length; i++) {
      if (text.indexOf(SUCCESS[i]) !== -1) return true;
    }
    return false;
  }

  function inspect() {
    document.querySelectorAll('[data-forms-id][data-vatpan-lead-pending="1"]').forEach(function (host) {
      if (!showsSuccess(host)) return;
      var id = host.getAttribute('data-forms-id');
      var name = host.getAttribute('data-vatpan-lead-name') || formName(id);
      if (window.vatpanTrackLead(id, name)) {
        host.removeAttribute('data-vatpan-lead-pending');
      }
    });
  }

  function hostFromPath(event) {
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node && node.getAttribute && node.getAttribute('data-forms-id')) return node;
    }
    return null;
  }

  function isSubmitControl(node) {
    if (!node || !node.matches) return false;
    return node.matches('button[type="submit"], input[type="submit"], button:not([type])');
  }

  document.addEventListener('click', function (event) {
    var host = hostFromPath(event);
    if (!host) return;
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      if (isSubmitControl(path[i])) {
        window.vatpanMarkLeadPending(host, formName(host.getAttribute('data-forms-id')));
        return;
      }
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var host = hostFromPath(event);
    if (host) window.vatpanMarkLeadPending(host, formName(host.getAttribute('data-forms-id')));
  }, true);

  captureClickIds();
  ensureTag();
  setInterval(inspect, 500);
})();
